import Header from "./shared/header";
import Footer from "./shared/footer";
import MobileLayout from "./shared/mobile_layout";
import { useState, useEffect } from "react";

import DesktopLayout from "./shared/desktop_layout";
import FeaturesSection from "./shared/outcomesWeDeliver/featuresSection";
import CaseStudies from "./shared/outcomesWeDeliver/CaseStudies";

function CustomerExperience() {
  const features = [
    {
      title: "IVR Modernization with Voice AI Agents",
      description:
        "Go beyond press-1-for-English. OBZ builds multilingual voice agents that handle routing, authentication, and resolution, deployed on your cloud, with no third-party lock-in.",
    },
    {
      title: "Chat Assistants & Messaging Automation",
      description:
        "Automate conversations across WhatsApp, Telegram, Viber, FB Messenger, SMS, in-app, and website, trained on your knowledge base and tuned for regional nuance.",
    },
    {
      title: "Agent Assist & Workflow Acceleration",
      description:
        "Reduce AHT and human error with real-time summarization, next-best actions, and recommended replies, embedded into CRMs like Salesforce and Zendesk.",
    },
    {
      title: "CX System Integration",
      description:
        "OBZ solutions plug into existing platforms, including Salesforce, Medallia, Genesys, NICE, and in-house call center solutions, to orchestrate seamless omnichannel service.",
    },
    {
      title: "Social Messaging & Support",
      description:
        "Extend customer care to where your customers are - TikTok, Facebook, Instagram, X - with AI agents that respond in real-time and escalate when needed.",
    },
    {
      title: "Voice of Customer & Feedback Loops",
      description:
        "Trigger surveys, capture sentiment, and feed insights back into CX systems, enabling a closed-loop approach to continuous experience improvement.",
    },
  ];

  const caseStudiesCards = [
    {
      text: "Custom Chat Agent at Scale",
      description:
        "Empowered non-technical teams to deploy 50+ chat flows using GenAI Studio-reducing time-to-launch for future use cases by up to 40%.",
      image:
        "/images/revenue-growth/OBZ Case Study Images Outcomes Customer Engagement.png",
      slug: "custom-chat-agent-at-scale",
    },
    {
      text: "Reactivating Dormant Users with ML-Powered CVM",
      description:
        "Designed and launched churn-focused campaigns using machine learning models, driving a 2.5× increase in conversions and projecting 1.5B VND in revenue uplift.",
      image:
        "/images/revenue-growth/OBZ Case Study Images Outcomes Customer Engagement2.png",
      slug: "reactivating-dormant-users-cvm",
    },
    {
      text: "AI Responder for Social Media at Scale",
      description:
        "Deployed a GenAI-powered wall responder across TikTok, X and Facebook, automating replies, escalating leads, and saving over $225K in agent costs.",
      image:
        "/images/revenue-growth/OBZ Case Study Images Outcomes Customer Engagement3.png",
      slug: "ai-responder-for-social-media",
    },
  ];

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <div>
      <Layout>
        <Header color="rgba(11, 21, 76, 1)" />
      </Layout>
      <Layout backgroundColor="black">
        <div className="w-full mt-10 py-16 lg:py-10">
          <div className="w-[88%] lg:w-[80%] mx-auto">
            {/* Header Section */}
            <div className="mb-12 lg:mb-7">
              <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-white RoobertLight leading-[120%] mb-4">
                Customer Experience
              </h2>
            </div>

            {/* Body Text */}
            <div className="mb-4 lg:mb-8 space-y-5">
              <p className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
                We help enterprises activate their data - not just analyze it -
                to unlock measurable top-line growth.From prepaid recharges and
                postpaid upsell in telco, to card acquisition and activation in
                banking, our solutions deliver fast, reliable, and repeatable
                outcomes.
              </p>
            </div>
            <div className="mb-4 lg:mb-7">
              <FeaturesSection features={features} />
              <h3 className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
                Our modular CVM framework, built from years of delivery across
                ASEAN and ANZ, helps enterprises move from concept to uplift in
                under 12 weeks.
              </h3>
            </div>
          </div>
        </div>
      </Layout>
      <Layout backgroundColor="black">
        <CaseStudies caseStudiesCards={caseStudiesCards} />
      </Layout>
      <Layout>
        <div className="w-full bg-fluoro-green py-16 lg:py-8 min-h-[500px] flex items-center justify-center relative">
          <div className="w-[88%] lg:w-[80%] py-5 px-5 h-full mx-auto relative bg-fluoro-green">
            <div className="mb-12 lg:mb-7 px-16 py-16">
              <p className="text-[16px] lg:text-[18px] text-[#0A1931] font-bolder RoobertSemiBold leading-[140%] mb-4">
                We work with CX, IT, and operations teams to co-develop
                solutions that meet regulatory, integration, and language needs.
                Our agentic delivery model helps clients modernize CX without
                replacing what already works while delivering measurable results
                across CSAT, FCR, and cost-to-serve.
              </p>
              <div className="border-r-4 border-t-4 border-[#0A1931] absolute top-0 right-0 w-1/4 h-1/2"></div>
              <div className="border-r-4 border-t-4 border-[#0A1931] absolute bottom-0 rotate-180 left-0 w-1/4 h-1/2"></div>
            </div>
          </div>
        </div>
      </Layout>
      <Layout>
        <Footer />
      </Layout>
    </div>
  );
}

export default CustomerExperience;
